import Vue from 'vue';
function setTatag(el, binding, vnode) {
    try {
        // // 添加页码前缀
        // const isPage = lodash.get(binding, 'modifiers.page');
        // // 获取页码名称
        // const pageName = isPage ? lodash.get(vnode, 'context.$route.name') : null;
        // // 拼接参数
        // const str = lodash.compact([pageName, binding.value]).join('_');
        el.setAttribute('latag', `latag_pc_${binding.value}`);
        // console.log("LENG ~ bind ~ el: HTMLDivElement, binding, vnode", el, binding)
    }
    catch (error) {
        console.error('LENG ~ bind ~ error', error);
    }
}
Vue.directive('latag', {
    bind: setTatag,
    componentUpdated: setTatag,
});
